<template>
  <el-table
    id="rebateSetTable"
    :data="extensionList"
    show-summary
    :summary-method="getSummaries"
    :max-height="tableHeight"
    v-loading="loading"
    element-loading-text="拼命加载中"
    element-loading-spinner="el-icon-loading"
    element-loading-background="rgba(0, 0, 0, 0.1)"
    ref="table"
  >
    <el-table-column
      v-for="(item, i) in column"
      :prop="item.key"
      :fixed="item.key == 'date' || item.key == 'geo'"
      :label="item.name"
      :key="i"
      align="center"
      :sortable="item.sort"
      :width="item.width"
      :sort-method="item.sortMethod"
    >
      <!-- <el-table-column :prop="item.key" :label="1" :key="i" align="center"> -->

      <!-- </el-table-column> -->
      <!-- <div v-if="item.children"> -->
      <el-table-column
        :prop="item.key"
        :label="totalColumn[i] + ''"
        :width="item.width"
        :key="i"
        align="center"
        v-if="!item.children"
      >
        <template slot-scope="scope">
          <span
            >{{ scope.row[item.key] ? item.unit : null
            }}{{ scope.row[item.key] }}</span
          >
        </template>
      </el-table-column>
      <el-table-column
        v-for="value in item.children"
        :prop="value.key"
        :label="value.name"
        :key="value.index"
        align="center"
        :width="value.width"
        :sortable="value.sort"
        :sort-method="value.sortMethod"
      >
        <el-table-column
          :prop="value.key"
          :label="totalColumn[value.index] + ''"
          :width="value.width"
          :key="value.index"
          align="center"
        >
          <template slot-scope="scope">
            <span
              >{{ scope.row[value.key] ? value.unit : null
              }}{{ scope.row[value.key] ? scope.row[value.key] : "-" }}</span
            >
          </template>
        </el-table-column>
      </el-table-column>
      <!-- </el-table-column> -->
      <!-- </div> -->
    </el-table-column>
  </el-table>
</template>

<script>
import XLSX from "xlsx";
import FileSaver from "file-saver";
export default {
  data() {
    return {
      tableHeight: window.innerHeight - 200,
    };
  },
  props: {
    extensionList: Array,
    // extensioHeader: Array,
    column: Array,
    loading: Boolean,
    totalColumn: Array,
  },
  mounted() {
    let _this = this;
    window.onresize = () => {
      return _this.refresh();
    };
  },
  methods: {
    downLoadFileToExcel() {
      let fix = document.querySelector(".el-table__fixed");
      var xlsxParam = { raw: true }; //导出的内容只做解析，不进行格式转换(添加此行代码表格中的百分比就不会再导出的时候被转换成小数点)
      let wb;
      if (fix) {
        //判断要导出的节点中是否有fixed的表格，如果有，转换excel时先将该dom移除，然后append回去
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable").removeChild(fix),
          xlsxParam
        );
        document.querySelector("#rebateSetTable").appendChild(fix);
      } else {
        wb = XLSX.utils.table_to_book(
          document.querySelector("#rebateSetTable"),
          xlsxParam
        );
      }
      let wbout = XLSX.write(wb, {
        bookType: "xlsx",
        bookSST: true,
        type: "array",
      });
      try {
        FileSaver.saveAs(
          new Blob([wbout], { type: "application/octet-stream" }),
          "推广报表.xlsx"
        );
      } catch (e) {
        if (typeof console !== "undefined") console.log(e, wbout);
      }
      return wbout;
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
          return;
        }
        // let currentItem = this.column.filter(v => v.key == column.property);
        let unitObj = {};
        this.column.map((v) => {
          if (v.key == column.property) {
            unitObj = v;
          } else if (v.key !== column.property && v.children) {
            v.children.map((val) => {
              val.key == column.property ? (unitObj = val) : null;
            });
          }
        });
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          if (unitObj.unit) {
            sums[index] = unitObj.unit + sums[index].toFixed(2);
          }
          // sums[index] += " 元";
        } else {
          sums[index] = "-";
        }
      });
      for (let i = 0; i < sums.length; i++) {
        if (i > 3 && i % 4 == 0) {
          sums[i + 2] = Number(sums[i].split("$")[1])
            ? `$${(Number(sums[i].split("$")[1]) / sums[i + 1]).toFixed(2)}`
            : "-";
        }
      }
      this.$emit("computTotalColumn", sums);
      return [];
    },
    refresh() {
      this.$nextTick(() => {
        this.$refs.table.doLayout();
      });
    },
  },
};
</script>
<style  lang="less" rel="stylesheet/less" scoped>
.el-table {
  overflow: visible !important;
}
</style>
